import { Component, Input, ChangeDetectorRef } from "@angular/core";
import { GraphicsInfoColorField } from "../../../../domain/graphics-info";

@Component({
  selector: "icn-graphics-colors",
  templateUrl: "./colors.component.html",
  styleUrls: ["./colors.component.scss"],
})
export class GraphicsColorsComponent {
  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  @Input() colorFields: Array<GraphicsInfoColorField>;

  colors = [];
}
